module.exports = __webpack_public_path__ + "static/media/nu.9fdf1a8f.svg";